import { FC, useContext } from "react";
import { useTranslation } from "@finbackoffice/site-core";
import { TranslationScopes } from "@finbackoffice/enums";
import classNames from "classnames";
import Input from "components/base/input-field/Input";
import { CasinoSearchBlockContext } from "../../CasinoSearchBlock";
import SearchResults from "../../results/SearchResults";
import styles from "./compact.module.sass";

const Compact: FC = () => {
    const { t } = useTranslation(TranslationScopes.Casino);
    const props = useContext(CasinoSearchBlockContext);
    const {
        minSearchCharCount,
        searchContainerRef,
        searchValue,
        handleInnerIconClick,
        handleChange,
        showSearchContainer,
        setShowSearchInput,
        showSearchInput,
    } = props;

    const onInnerIconClick = () => {
        setShowSearchInput(false);
        handleInnerIconClick();
    };

    return (
        <div className={styles.searchContainer} ref={searchContainerRef}>
            <Input
                type="text"
                name="query"
                placeholder={t("casino_searchPlaceholder", {
                    replace: {
                        count: minSearchCharCount,
                    },
                })}
                wrapperClassname={classNames(styles.searchField, {
                    [styles.open]: showSearchInput,
                })}
                innerIconClass={styles.closeSearch}
                onInnerIconClick={onInnerIconClick}
                onIconClick={() => setShowSearchInput(true)}
                iconClass={styles.searchIcon}
                value={searchValue}
                onChange={handleChange}
            />
            {showSearchContainer && <SearchResults {...props} searchValue={searchValue} />}
        </div>
    );
};

export default Compact;
